import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Collapse } from "react-bootstrap";

import find from "lodash/find";
import * as roleActions from "../../actions/roleActions";
import * as modalActions from "../../actions/modalActions";

import RoleList from "./RoleList";
import RoleForm from "./RoleForm";
import HeaderWrapper from "../common/HeaderWrapper";
import Modal from "../common/Modal";
import ConfirmModal from "../common/ConfirmModal";

class RolePage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      role: {},
      open: false,
      adding: false
    };
  }

  componentDidMount = () => {
    this.props.actions.loadRoles();
  };

  onClickAdd = () => {
    this.setState({ role: {}, open: !this.state.open, adding: true });
  };

  onClickEdit = (roleId) => {
    const role = find(this.props.roles, { id: roleId });
    this.setState({ role, adding: false });
    this.props.actions.getRole(roleId, true);
  };

  onClickDelete = (roleId) => {
    this.props.actions.requestRoleId(roleId);
  };

  handleAdd = (role) => {
    this.props.actions.createRole(role);
  };

  handleSave = (role) => {
    role.id = this.props.role._id;
    this.props.actions.updateRole(role);
    this.props.actions.hideModal();
  };

  handleDelete = () => {
    this.props.actions.deleteRole(this.props.roleToDelete);
  };

  handleCancel = () => {
    this.props.actions.hideModal();
  };

  filter = (e) => {
    this.setState({ search: e.target.value });
  };

  render() {
    const { role, adding } = this.state;

    const roleForm = (
      <RoleForm
        role={role}
        onAdd={this.handleAdd}
        onSave={this.handleSave}
        onCancel={this.handleCancel}
        saving={this.props.savingRole}
        editing
        adding={adding}
      />
    );

    return (
      <>
        <HeaderWrapper
          breadcrumbs={[{ label: "Settings" }, { label: "Roles" }]}
          onClickAdd={this.onClickAdd}
        />
        <div>
          <Collapse in={this.state.open}>
            <div>
              <div className="content-wrapper">
                <h4>Add Role</h4>
                {roleForm}
              </div>
            </div>
          </Collapse>
        </div>
        <div className="content-wrapper">
          <RoleList
            roles={this.props.roles}
            onClickEdit={this.onClickEdit}
            onClickDelete={this.onClickDelete}
          />
          <Modal
            id="roleDetailsModal"
            title="Role Info"
            body={roleForm}
            close={this.props.actions.hideModal}
          />
          <ConfirmModal
            id="roleDeleteModal"
            title="Delete Role"
            body="Are you sure you want to delete this role?"
            close={this.props.actions.hideModal}
            confirm={this.handleDelete}
          />
        </div>
      </>
    );
  }
}

RolePage.propTypes = {
  actions: PropTypes.object,
  savingRole: PropTypes.bool,
  roleToDelete: PropTypes.string,
  roles: PropTypes.array.isRequired,
  role: PropTypes.object.isRequired
};

function mapStatesToProps(state) {
  return {
    state: state.reducers,

    savingRole: state.reducers.savingRole,
    roleToDelete: state.reducers.roleToDelete,
    roles: state.reducers.roles,
    role: state.reducers.role
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...roleActions, ...modalActions }, dispatch)
  };
}

export default connect(mapStatesToProps, mapDispatchToProps)(RolePage);
